import React, { Component } from "react";
import { Form } from "react-bootstrap";
import CheckBoxChecked from "../../images/check_box_checked.svg";
import CheckBoxUnCheck from "../../images/check_box_uncheck.svg";

export default class CheckBoxComponent extends Component {

    render() {
        const { text, checked, onChange } = this.props;
        const imgSource = checked ? CheckBoxChecked : CheckBoxUnCheck;

        return (
            <Form.Group className="d-flex">
            <div
              className="d-flex align-item-center"
              onClick={() => onChange(!checked) }
            >
              <img
                src={imgSource}
                className="mr-2"
                width="24px"
                height="24px"
              />
              <p className="mb-0">{text}</p>
            </div>
          </Form.Group>
        )
    }
}